import {
  SQUAD_KEY,
  SQUAD_PATH
} from 'modules/squad/redux/constants'
import joinPathsStrUtil from 'utils/string/join-paths'

const getProductsPathByMemberIdAndFilterTypeSquadUtilSquadUtil = (id, filterType) => {
  return joinPathsStrUtil(
    SQUAD_PATH[SQUAD_KEY.MEMBER_ID_TO_FILTER_TYPE_PRODUCTS],
    id,
    filterType
  )
}

export default getProductsPathByMemberIdAndFilterTypeSquadUtilSquadUtil
